import { createStore, applyMiddleware } from 'redux';

const initialStore = {
    code: undefined,
    companyLogo: undefined,
    name: '',
    rut: '',
    token: undefined,
    component: 'home_without_code',
    stepInfo: {},
    image: undefined,
    data: undefined,
    stepData: {},
    loader: true,
    showError: false,
    errorType: 'default',
    errorMessage: '',
    errorData: {},
    isSigned: false,
    expiration: undefined,
    setExpirationSecondsToken: undefined,
    windowVisibility: true,
    multiple: undefined,
    messageModalVisibility: false,
    passwordType: undefined,
    source: undefined,
    identityType: undefined,
    documents: [],
    modalButton:false,
    tab: 0,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_CODE':
            return {
                ...state,
                code: action.code
            };
        case 'SET_COMPONENT':
            return {
                ...state,
                component: action.component
            };
        case 'SET_NAME':
            return {
                ...state,
                name: action.name
            };
        case 'SET_RUT':
            return {
                ...state,
                rut: action.rut
            };
        case 'SET_TOKEN':
            return {
                ...state,
                token: action.token
            };
        case 'SET_EXPIRATION':
            return {
                ...state,
                expiration: action.expiration
            };
        case 'SET_EXPIRATION_SECONDS_TOKEN':
            return {
                ...state,
                expirationSecondsToken: action.expirationSecondsToken
            };
        case 'SET_STEP_INFO':
            return {
                ...state,
                stepInfo: action.stepInfo
            };
        case 'SET_IMAGE':
            return {
                ...state,
                image: action.image
            };
        case 'SET_STEP_DATA':
            return {
                ...state,
                stepData: action.stepData
            };
        case 'SET_LOADER':
            return {
                ...state,
                loader: action.loader
            };
        case 'SET_SHOW_ERROR':
            return {
                ...state,
                showError: action.showError
            };
        case 'SET_ERROR_TYPE':
            return {
                ...state,
                errorType: action.errorType
            };
        case 'SET_ERROR_MESSAGE':
            return {
                ...state,
                errorMessage: action.errorMessage
            };
        case 'SET_ERROR_DATA':
            return {
                ...state,
                errorData: action.errorData
            }
        case 'SET_IS_SIGNED':
            return {
                ...state,
                isSigned: action.isSigned
            };

        case 'SET_MULTIPLE':
            return {
                ...state,
                multiple: action.multiple,
            };
        case 'SET_WINDOW_VISIBILITY':
            return {
                ...state,
                windowVisibility: action.windowVisibility
            };
        case 'SET_MESSAGE_MODAL_VISIBILITY':
            return {
                ...state,
                messageModalVisibility: action.messageModalVisibility
            };
        case 'SET_PASSWORD_TYPE':
            return {
                ...state,
                passwordType: action.passwordType
            };
        case 'SET_COMPANY_LOGO':
            return {
                ...state,
                companyLogo: action.companyLogo
            };
        case 'SET_SOURCE':
            return {
                ...state,
                source: action.source
            };
        case 'SET_IDENTITY_TYPE':
            return {
                ...state,
                identityType: action.identityType
            };
        case 'SET_DOCUMENTS':
            return {
                ...state,
                documents: action.documents
            };
        case 'SET_DATA':
            return {
                ...state,
                data: action.data
            };
        case 'SET_MODAL_BUTTON':
            return {
                ...state,
                modalButton: action.modalButton
            };
        case 'RESET_ALL_DATA':
            return initialStore;
        case 'SET_PLATE':
            return {
                ...state,
                plate: action.plate,
            };
        case 'SET_TAB':
                return {
                    ...state,
            tab: action.tab,
            };
        default:
            return state;
    }
};

const logger = store => next => action => {
    //console.log('dispatching', action);
    let result = next(action);
    //console.log('next state', store.getState());
    return result;
};

export default createStore(reducer, initialStore, applyMiddleware(logger));
